import React from "react";
import styles from "./boardDirectors.module.css";
import heroImage from "../../assets/images/boardOfDirectors/board.png";
import heroImageResponsive from "../../assets/images/boardOfDirectors/boardResponsive.png";
const BoardDirectors = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.text}>
          <h1>Board of Directors</h1>
          <p>
            CFH is one of the fastest growing investment banks in Egypt,
            providing full-fledged services in corporate finance & investment
            banking, asset management, securities brokerage, private equity, and
            equity research.
          </p>
        </div>
        <div className={styles.image}>
          <img
            src={heroImage}
            alt="CFH representative"
            className={styles.representativeImage}
          />
          <img
            src={heroImageResponsive}
            alt="CFH representative"
            className={styles.representativeResponsiveImage}
          />
        </div>
      </div>
    </section>
  );
};

export default BoardDirectors;
